import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _styled from "styled-components";
import { colorMap, fontSizeMapToStandard, fontWeightMap } from './title.constants';
export var TitleWrapper = /*#__PURE__*/_styled.span.withConfig({
  displayName: "titlestyled-components__TitleWrapper",
  componentId: "sc-fui06p-0"
})(function (_ref) {
  var fontSize = _ref.fontSize,
      isCenter = _ref.isCenter,
      wrapperStyle = _ref.wrapperStyle,
      desktopOnly = _ref.desktopOnly,
      mobileOnly = _ref.mobileOnly,
      textColor = _ref.textColor;
  return [{
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "gap": "0.375rem"
  }, fontSize && standardTitleVariants[fontSizeMapToStandard(fontSize)], isCenter && {
    "justifyContent": "center",
    "textAlign": "center"
  }, textColor ? colorMap[textColor] : {}, desktopOnly ? {
    "display": "none",
    "@media (min-width: 1024px)": {
      "display": "flex"
    }
  } : {}, mobileOnly ? {
    "display": "flex",
    "@media (min-width: 1024px)": {
      "display": "none"
    }
  } : {}].concat(_toConsumableArray(wrapperStyle ? Array.isArray(wrapperStyle) ? wrapperStyle : [wrapperStyle] : []));
});
export var IconWrapper = /*#__PURE__*/_styled.span.withConfig({
  displayName: "titlestyled-components__IconWrapper",
  componentId: "sc-fui06p-1"
})({
  "display": "inline-flex",
  "flexShrink": "0",
  "alignItems": "center",
  "justifyContent": "center"
});
export var TitleContent = /*#__PURE__*/_styled.span.withConfig({
  displayName: "titlestyled-components__TitleContent",
  componentId: "sc-fui06p-2"
})(function (_ref2) {
  var textColor = _ref2.textColor,
      fontWeight = _ref2.fontWeight,
      isPointer = _ref2.isPointer,
      twStyle = _ref2.twStyle,
      variant = _ref2.variant,
      standardVariant = _ref2.standardVariant,
      align = _ref2.align;
  return [textColor ? colorMap[textColor] : {}, isPointer ? {
    "cursor": "pointer"
  } : {}, variant ? standardTitleVariants[mapTitleProps(variant)] : {}, standardVariant ? standardTitleVariants[standardVariant] : {}, align ? alignment[align] : {}, fontWeight ? fontWeightMap[fontWeight] : {}, twStyle && !Array.isArray(twStyle) ? twStyle : {}].concat(_toConsumableArray(twStyle && Array.isArray(twStyle) ? twStyle : []));
});
export var standardTitleVariants = {
  // Text 6xl
  'display-1': {
    "fontSize": "48px",
    "fontWeight": "700",
    "lineHeight": "72px",
    "@media (min-width: 1024px)": {
      "fontSize": "60px",
      "lineHeight": "90px"
    }
  },
  // Text 5xl
  'display-2': {
    "fontSize": "48px",
    "fontWeight": "600",
    "lineHeight": "72px",
    "@media (min-width: 1024px)": {
      "fontSize": "48px",
      "lineHeight": "72px"
    }
  },
  // Text 4xl
  h1: {
    "fontSize": "30px",
    "fontWeight": "600",
    "lineHeight": "45px",
    "@media (min-width: 1024px)": {
      "fontSize": "36px",
      "lineHeight": "54px"
    }
  },
  // Text 3xl
  h2: {
    "fontSize": "24px",
    "fontWeight": "600",
    "lineHeight": "36px",
    "@media (min-width: 1024px)": {
      "fontSize": "30px",
      "lineHeight": "45px"
    }
  },
  // Text 2xl
  h3: {
    "fontSize": "24px",
    "fontWeight": "600",
    "lineHeight": "36px",
    "@media (min-width: 1024px)": {
      "fontSize": "24px",
      "lineHeight": "36px"
    }
  },
  // Text xl
  h4: {
    "fontSize": "20px",
    "fontWeight": "600",
    "lineHeight": "30px",
    "@media (min-width: 1024px)": {
      "fontSize": "20px",
      "lineHeight": "30px"
    }
  },
  // Text lg
  h5: {
    "fontSize": "16px",
    "fontWeight": "600",
    "lineHeight": "24px",
    "@media (min-width: 1024px)": {
      "fontSize": "16px",
      "lineHeight": "24px"
    }
  }
};

/**
 * Maps a standardVariant to its corresponding semantic HTML element.
 * Returns undefined for non-semantic variants (display-1, display-2),
 * allowing the default <span> to be used.
 */
export var standardVariantToHtmlElement = function standardVariantToHtmlElement(variant) {
  switch (variant) {
    case 'h1':
      return 'h1';

    case 'h2':
      return 'h2';

    case 'h3':
      return 'h3';

    case 'h4':
      return 'h4';

    case 'h5':
      return 'h5';

    default:
      return undefined;
  }
};
/**
 * Maps a variant (legacy system) to its corresponding semantic HTML element.
 * Derives the heading level from the variant prefix (h1-*, h2-*, etc.).
 */

export var variantToHtmlElement = function variantToHtmlElement(variant) {
  if (!variant) return undefined;
  var match = variant.match(/^(h[1-6])/);
  return match ? match[1] : undefined;
};
var variantMap = {
  h1: {
    "fontSize": "1rem",
    "lineHeight": "1.5rem",
    "fontWeight": "600",
    "--tw-text-opacity": "1",
    "color": "rgb(28 19 39 / var(--tw-text-opacity))",
    "@media (min-width: 1024px)": {
      "fontSize": "2.25rem",
      "lineHeight": "3.375rem"
    }
  },
  'h1-medium': {
    "fontSize": "1.5rem",
    "lineHeight": "2.25rem",
    "--tw-text-opacity": "1",
    "color": "rgb(28 19 39 / var(--tw-text-opacity))",
    "@media (min-width: 1024px)": {
      "fontSize": "2.25rem",
      "lineHeight": "3.375rem"
    }
  },
  'h1-small': {
    "fontSize": "1.25rem",
    "lineHeight": "1.875rem",
    "@media (min-width: 1024px)": {
      "fontSize": "2.25rem",
      "lineHeight": "3.375rem"
    }
  },
  h2: {
    "fontSize": "1.875rem",
    "lineHeight": "2.25rem",
    "fontWeight": "700"
  },
  'h2-medium': {
    "fontSize": "1.5rem",
    "lineHeight": "1.75rem",
    "@media (min-width: 1024px)": {
      "fontSize": "1.875rem",
      "lineHeight": "45px"
    }
  },
  'h2-large': {
    "fontSize": "1.5rem",
    "lineHeight": "2.25rem",
    "@media (min-width: 1024px)": {
      "fontSize": "1.875rem",
      "lineHeight": "3.375rem"
    }
  },
  h3: {
    "fontSize": "1.5rem",
    "lineHeight": "2rem",
    "fontWeight": "700"
  },
  'h3-large': {
    "fontSize": "1.5rem",
    "lineHeight": "2.25rem",
    "@media (min-width: 1024px)": {
      "fontSize": "1.5rem",
      "lineHeight": "2.25rem"
    }
  },
  'h3-medium': {
    "fontSize": "1.25rem",
    "lineHeight": "1.875rem",
    "@media (min-width: 1024px)": {
      "fontSize": "1.5rem",
      "lineHeight": "2.25rem"
    }
  },
  'h3-small': {
    "fontSize": "1.125rem",
    "lineHeight": "1.688rem",
    "@media (min-width: 1024px)": {
      "fontSize": "1.5rem",
      "lineHeight": "2rem"
    }
  },
  'h3-xsmall': {
    "fontSize": "1.125rem",
    "lineHeight": "1.688rem",
    "@media (min-width: 1024px)": {
      "fontSize": "1.5rem",
      "lineHeight": "1.875rem"
    }
  },
  h4: {
    "fontSize": "0.875rem",
    "lineHeight": "1.313rem",
    "@media (min-width: 1024px)": {
      "fontSize": "1.25rem",
      "lineHeight": "1.875rem"
    }
  },
  'h4-xlarge': {
    "fontSize": "1.125rem",
    "lineHeight": "1.688rem",
    "@media (min-width: 1024px)": {
      "fontSize": "1.25rem",
      "lineHeight": "1.875rem"
    }
  },
  'h4-medium': {
    "fontSize": "1.25rem",
    "lineHeight": "1.75rem",
    "@media (min-width: 1024px)": {
      "fontSize": "1.25rem",
      "lineHeight": "1.75rem"
    }
  },
  'h4-large': {
    "fontSize": "1.25rem",
    "lineHeight": "1.875rem",
    "@media (min-width: 1024px)": {
      "fontSize": "1.25rem",
      "lineHeight": "1.875rem"
    }
  },
  'h4-small': {
    "fontSize": "1rem",
    "lineHeight": "1.5rem",
    "@media (min-width: 1024px)": {
      "fontSize": "1.25rem",
      "lineHeight": "1.875rem"
    }
  },
  'h4-xsmall': {
    "fontSize": "1rem",
    "lineHeight": "1.5rem",
    "@media (min-width: 1024px)": {
      "fontSize": "1.25rem",
      "lineHeight": "2.25rem"
    }
  },
  h5: {
    "fontSize": "1.125rem",
    "lineHeight": "1.75rem",
    "fontWeight": "700"
  },
  'h5-large': {
    "fontSize": "1.125rem",
    "lineHeight": "1.688rem",
    "@media (min-width: 1024px)": {
      "fontSize": "1.125rem",
      "lineHeight": "1.688rem"
    }
  },
  'h5-medium': {
    "fontSize": "1rem",
    "lineHeight": "1.5rem",
    "@media (min-width: 1024px)": {
      "fontSize": "1.125rem",
      "lineHeight": "1.688rem"
    }
  },
  h6: {
    "fontSize": "1rem",
    "lineHeight": "1.5rem",
    "fontWeight": "700"
  },
  'h6-large': {
    "fontSize": "1rem",
    "lineHeight": "1.5rem",
    "@media (min-width: 1024px)": {
      "fontSize": "1rem",
      "lineHeight": "1.5rem"
    }
  },
  'h6-medium': {
    "fontSize": "0.875rem",
    "lineHeight": "1.313rem",
    "@media (min-width: 1024px)": {
      "fontSize": "1rem",
      "lineHeight": "1.5rem"
    }
  },
  'h6-xsmall': {
    "fontSize": "0.875rem",
    "lineHeight": "1.313rem",
    "@media (min-width: 1024px)": {
      "fontSize": "0.875rem",
      "lineHeight": "1.313rem"
    }
  }
};
var alignment = {
  left: {
    "textAlign": "left"
  },
  center: {
    "textAlign": "center"
  },
  right: {
    "textAlign": "right"
  },
  justify: {
    "textAlign": "justify"
  }
};
export var mapTitleProps = function mapTitleProps(variant) {
  switch (variant) {
    case 'h1':
    case 'h1-medium':
    case 'h1-small':
      return 'h1';

    case 'h2':
    case 'h2-medium':
    case 'h2-large':
      return 'h2';

    case 'h3':
    case 'h3-large':
    case 'h3-medium':
    case 'h3-small':
    case 'h3-xsmall':
      return 'h3';

    case 'h4-medium':
    case 'h4-large':
    case 'h4-xlarge':
    case 'h4-small':
    case 'h4':
    case 'h4-xsmall':
      return 'h4';

    case 'h5':
    case 'h5-large':
    case 'h5-medium':
      return 'h4';

    default:
      return 'h5';
  }
};